// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"5a11447e","773":"0bc39fa6"}[chunkId] + ".chunk.js";
};